
import iteratorsCommons from "@/components/UserInterfaces/renderer/mixins/iterators-commons";
import ComponentRenderer from "@/components/UserInterfaces/renderer/ComponentRenderer.vue";
import NamespaceRenderer from "@/components/UserInterfaces/renderer/NamespaceRenderer.vue";
import { mapState } from "vuex";

export default {
    name: "LineRenderer",
    components: { ComponentRenderer, NamespaceRenderer },
    mixins: [iteratorsCommons],
    props: {
        data: { type: Object, default: () => ({}) },
        line: { type: Array, required: true },
        path: { type: Array, default: () => [] },
        namespace: { type: String, default: "" },
        teleportTo: { type: String, default: "" }
    },
    data() {
        return {
        };
    },
    computed: {
        ...mapState("components", ["activeComponent"])
    },
    methods: {
        isActive({ guid }) {
            return this.activeComponent && (this.activeComponent === guid);
        },
        getComponentProperties({ guid }) {
            return this.properties[guid];
        },
        getComponentConfig({ guid }) {
            const properties = this.properties[guid];
            return this.components[properties.__component];
        },
        isNamespaceType({ guid }) {
            const config = this.getComponentConfig({ guid });
            return !!config.namespace;
        },
        getComponentData({ guid }) {
            const config = this.getComponentConfig({ guid });
            const data = this.$_get(this.data, [...this.path, guid], null);

            if (config.namespace) {
                data.forEach(dataEntry => {
                    if (!dataEntry.__ns) {
                        dataEntry.__ns = this.$generateUID();
                    }
                });
            }

            return data;
        }
    }
};
